import { defineMessages } from 'react-intl'

/** Event brands and checkout payment / gift-card copy — `docs/product-taxonomy.md` §13. */
const paymentsGlossaryMessages = defineMessages({
  luxuryEscapesLive: {
    defaultMessage: 'Luxury Escapes Live',
    id: 'hUnE-N-5qXjXoWzYp7I1',
  },
  luxuryEscapesLive2026: {
    defaultMessage: 'Luxury Escapes Live 2026',
    id: 'CbnSx43i1lNwtP4bxNka',
  },
  exclusiveEventOnlyOffers: {
    defaultMessage: 'Exclusive event-only offers',
    id: 'M1ZK034tpymaRL2TjKmh',
  },
  dontMissLuxuryEscapesLive: {
    defaultMessage: "Don't Miss Luxury Escapes Live",
    id: 'kHOzDk52s67LlKxgWeFz',
  },
  luxPay: {
    defaultMessage: 'LuxPay',
    id: 'LZ6UfDG1CzdRaSh2aPbT',
  },
  payWithGiftCard: {
    defaultMessage: 'Pay with Gift Card',
    id: 'lHKQzbnqNxTi6C8GOppt',
  },
  addAGiftCard: {
    defaultMessage: 'Add a Gift Card',
    id: 'kuI0t4y_oLWwrOeFpHS4',
  },
})

export default paymentsGlossaryMessages
